// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cv-row__margins .bx--toast-notification--info{background:#edf5ff}.cv-row__margins .bx--toast-notification__subtitle,.cv-row__margins .bx--toast-notification__title{color:#000;font-size:14px}.cv-row__margins .bx--toast-notification__close-icon{fill:#000!important}.cv-row__margins .info-notification{z-index:0;width:100%;height:68px;margin-left:12px;margin-right:20px}.cv-row__margins{position:relative;margin-left:1.6px;margin-right:1.6px;margin-top:1.6px}", ""]);
// Exports
module.exports = exports;
